import NextImage from "@components/NextImage";
/* eslint-disable react-hooks/rules-of-hooks */
import {useRouter} from "next/router";
import {useTranslation} from "ni18n";
import React from "react";
import {useTypedSelector} from "src/store";

import {downloadUrlDeeplink} from "../_common/_constants";
import {trackToPatient} from "../_common/Carbon";
import styles from "./Insurances.module.scss";
import {Btn} from "./V5Comp";

const insuranceList: string[] = [
  "/anthem",
  "/blueshield",
  "/cigna",
  "/aarp",
  "/unitedhealthcare",
  "/healthnet",
];

const Insurances = () => {
  const i18n = useTranslation();
  const {isMobile} = useTypedSelector(({config}) => config);
  const router = useRouter();

  // Strings
  const tag = i18n.t("Simplified Billing");
  const header = i18n.t("We accept all major insurance plans.");
  const subheader = i18n.t("Just scan your insurance card and then you're all set.");
  const button = i18n.t("Get Started Now");

  const insurances = insuranceList.map(insurance => (
    <li key={insurance} className={styles["insurance-container"]}>
      <NextImage
        className={styles.img}
        width={150}
        height={150}
        src={insurance}
        alt={insurance.replace("/", "")}
      />
    </li>
  ));

  insurances.unshift(
    <li key="insurance-padding1" className={styles["insurance-container"]}>
      <NextImage
        className={styles.img}
        width={150}
        height={150}
        src={insuranceList[5]}
        alt={insuranceList[5].replace("/", "")}
      />
    </li>,
  );

  insurances.push(
    <li key="insurance-padding2" className={styles["insurance-container"]}>
      <NextImage
        className={styles.img}
        width={150}
        height={150}
        src={insuranceList[0]}
        alt={insuranceList[0].replace("/", "")}
      />
    </li>,
  );

  const downloadUrl = isMobile ? downloadUrlDeeplink : "/download";

  const clickHandler = () =>
    isMobile &&
    trackToPatient({
      ga: {
        category: "Download app",
        action: "Link to app store",
        label: router.pathname,
      },
    });

  return (
    <section
      className={`${styles.outer} contrast-tbt`}
      aria-label={i18n.t("Insurance Information")}
    >
      <div className={styles.circle}>
        <div className={styles.inner}>
          <span className={styles.tag}>{tag}</span>
          <h2 className={`${styles.header} fw4`}>{header}</h2>
          <strong className={`${styles.subheader} fw4`}>{subheader}</strong>
          <Btn href={downloadUrl} className={styles.button} onClick={clickHandler}>
            {button}
          </Btn>
        </div>
      </div>
      <ul className={styles.insurances}>{insurances}</ul>
      <ul className={styles.insurances2} aria-hidden>
        {insurances}
      </ul>
      <div className={styles.phone}>
        <NextImage
          width={498}
          height={948}
          src="/insurance-scan-phone"
          alt={i18n.t("Scan your insurance card with your phone")}
        />
      </div>
      <div className={styles["insurance-card"]}>
        <NextImage width={322} height={154} src="/insurance-card" alt="" />
      </div>
    </section>
  );
};

export default Insurances;
